import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {injectIntl, FormattedMessage} from 'react-intl';
import CustomScrollDiv from '../../forecast-app/shared/components/scroll-bars/custom_scroll_div';

class PermissionsInfoModal extends Component {
	closeModal() {
		this.props.closeModal();
	}

	render() {
		const {formatMessage} = this.props.intl;
		const actions = [
			{translationId: 'permissions_modal.action_edit_assigned_cards', virtual: false, client: true, collaborator: true, manager: true, controller: true, admin: true},
			{translationId: 'permissions_modal.action_edit_cards', virtual: false, client: false, collaborator: true, manager: true, controller: true, admin: true},
			{translationId: 'permissions_modal.action_view_assigned_projects', virtual: false, client: true, collaborator: true, manager: true, controller: true, admin: true},
			{translationId: 'permissions_modal.action_report_edit_own_time', virtual: false, client: true, collaborator: true, manager: true, controller: true, admin: true},
			{translationId: 'permissions_modal.action_edit_members_time', virtual: false, client: false, collaborator: false, manager: true, controller: true, admin: true},
			{
				translationId: 'permissions_modal.action_manage_project_clients_reports',
				virtual: false,
				client: false,
				collaborator: false,
				manager: true,
				controller: true,
				admin: true,
			},
			{translationId: 'permissions_modal.action_edit_workflow', virtual: false, client: false, collaborator: false, manager: true, controller: true, admin: true},
			{translationId: 'permissions_modal.action_schedule', virtual: false, client: false, collaborator: false, manager: true, controller: true, admin: true},
			{translationId: 'permissions_modal.action_add_members_to_project', virtual: false, client: false, collaborator: false, manager: true, controller: true, admin: true},
			{translationId: 'permissions_modal.action_add_members', virtual: false, client: false, collaborator: false, manager: true, controller: true, admin: true},
			{translationId: 'permissions_modal.action_manage_finance', virtual: false, client: false, collaborator: false, manager: false, controller: true, admin: true},
			{translationId: 'permissions_modal.action_view_finance', virtual: false, client: false, collaborator: false, manager: false, controller: true, admin: true},
			{translationId: 'permissions_modal.action_manage_billing', virtual: false, client: false, collaborator: false, manager: false, controller: true, admin: true},
			{translationId: 'permissions_modal.action_manage_all_projects', virtual: false, client: false, collaborator: false, manager: false, controller: false, admin: true},
			{translationId: 'permissions_modal.action_manage_roles', virtual: false, client: false, collaborator: false, manager: false, controller: false, admin: true},
			{translationId: 'permissions_modal.action_delete_clients_rates', virtual: false, client: false, collaborator: false, manager: false, controller: false, admin: true},
			{translationId: 'permissions_modal.action_manage_notification', virtual: false, client: false, collaborator: false, manager: false, controller: false, admin: true},
			{translationId: 'permissions_modal.action_manage_time_registration_categories', virtual: false, client: false, collaborator: false, manager: false, controller: false, admin: true},
			{translationId: 'permissions_modal.action_manage_integrations', virtual: false, client: false, collaborator: false, manager: false, controller: false, admin: true},
			{translationId: 'permissions_modal.action_close_account', virtual: false, client: false, collaborator: false, manager: false, controller: false, admin: true},
		];
		return (
			<div className="layer" onMouseDown={this.closeModal.bind(this)}>
				<div className="permissions-info-modal">
					<div
						className="inner"
						onMouseDown={e => {
							e.stopPropagation();
						}}
					>
						<div className="container">
							<div className="header">
								<h3>
									<FormattedMessage id="permissions_modal.title" />
								</h3>
								<button className="close-button" onClick={this.closeModal.bind(this)} />
							</div>
							<div className="body">
								<CustomScrollDiv>
									<div className="summary">
										<div className="roles">
											<div className="role-info">
												<span className="role-name">{formatMessage({id: 'permissions_modal.user_type_admin'})}:</span>
												<span className="role-description">{formatMessage({id: 'permissions_modal.admin_description'})}</span>
											</div>
											<div className="role-info">
												<span className="role-name">{formatMessage({id: 'permissions_modal.user_type_controller'})}:</span>
												<span className="role-description">{formatMessage({id: 'permissions_modal.controller_description'})}</span>
											</div>
											<div className="role-info">
												<span className="role-name">{formatMessage({id: 'permissions_modal.user_type_owner'})}:</span>
												<span className="role-description">{formatMessage({id: 'permissions_modal.owner_description'})}</span>
											</div>
											<div className="role-info">
												<span className="role-name">{formatMessage({id: 'permissions_modal.user_type_collaborator'})}:</span>
												<span className="role-description">{formatMessage({id: 'permissions_modal.collaborator_description'})}</span>
											</div>
											<div className="role-info">
												<span className="role-name">{formatMessage({id: 'permissions_modal.user_type_virtual'})}: </span>
												<span className="role-description">{formatMessage({id: 'permissions_modal.virtual_description'})}</span>
											</div>
										</div>
									</div>
									<div className="table-wrapper">
										<table>
											<thead>
												<tr>
													<th className="col-action">
														<span>{formatMessage({id: 'shortcut_modal.action'})}</span>
													</th>
													<th className="col-role">{formatMessage({id: 'permissions_modal.user_type_admin'})}</th>
													<th className="col-role">{formatMessage({id: 'permissions_modal.user_type_controller'})}</th>
													<th className="col-role">{formatMessage({id: 'permissions_modal.user_type_owner'})}</th>
													<th className="col-role">{formatMessage({id: 'permissions_modal.user_type_collaborator'})}</th>
													<th className="col-role">{formatMessage({id: 'permissions_modal.user_type_virtual'})}</th>
												</tr>
											</thead>
											<tbody>
												{actions.map((action, index) => (
													<tr key={index}>
														<td>
															<FormattedMessage id={action.translationId} />
														</td>
														<td>
															<div className={action.admin ? 'true' : ''} />
														</td>
														<td>
															<div className={action.controller ? 'true' : ''} />
														</td>
														<td>
															<div className={action.manager ? 'true' : ''} />
														</td>
														<td>
															<div className={action.collaborator ? 'true' : ''} />
														</td>
														<td>
															<div className={action.virtual ? 'true' : ''} />
														</td>
													</tr>
												))}
											</tbody>
										</table>
									</div>
								</CustomScrollDiv>
							</div>
							<div className="bottom">{/* <button onClick={this.closeModal.bind(this)}>
									<FormattedMessage id="permissions_modal.close_button" />
								</button> */}</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
PermissionsInfoModal.propTypes = {
	closeModal: PropTypes.func.isRequired,
};
export default injectIntl(PermissionsInfoModal);
